<template>
    <v-container
        class="white pb-10"
    >
                <!--------------------------------->
                <!--     Close Dialog Button     -->
                <!--------------------------------->
        <v-tooltip
            left
        >
            <template v-slot:activator="{ on: tooltip}">
                <v-btn
                    small
                    fab
                    fixed
                    top
                    right
                    @click="closeEditRecipe"
                    :disabled="processing"
                    v-on="{ ...tooltip}"
                    style="top: 10px; right: 25px;"
                >
                    <v-icon>
                        close
                    </v-icon>
                </v-btn>
            </template>
            <span>
                Close
            </span>
        </v-tooltip>


                <!--------------------------------->
                <!--         Save Recipe         -->
                <!--------------------------------->
        <v-tooltip
            left
        >
            <template v-slot:activator="{ on: tooltip}">
                <v-btn
                    small
                    fab
                    fixed
                    top
                    right
                    @click.prevent="editExistingRecipe"
                    :disabled="disableSaveEditRecipe || processing"
                    v-on="{ ...tooltip}"
                    style="top: 60px; right: 25px;"
                >
                    <v-icon
                        v-if="!processing"
                    >
                        save
                    </v-icon>
                    <v-progress-circular
                        v-if="processing"
                        :size="40"
                        :width="6"
                        color="#74cf74"
                        indeterminate
                    ></v-progress-circular>
                </v-btn>
            </template>
            <span>
                Save
            </span>
        </v-tooltip>

        <div
            v-if="errorMessage != null"
            no-gutters
            style="position: fixed; top: 68px; right: 90px;"
        >
            <v-col
                class="text-right mt-1 pt-0 mx-5 red--text caption"
            >
                {{errorMessage}}
            </v-col>
        </div>

                <!--------------------------------->
                <!--        Delete Recipe        -->
                <!--------------------------------->
        <v-dialog
            v-if="account.account_type == 'admin' || account.account_type == 'super admin'"
            v-model="deleteRecipeDialog"
            persistent
            width="500"
            style="overflow-x: hidden"
        >
            <template
                v-slot:activator="{ on: deleteRecipe }"
            >
                <v-tooltip
                    left
                >
                    <template v-slot:activator="{ on: tooltip}">
                        <v-btn
                            small
                            fab
                            fixed
                            top
                            right
                            :disabled="processing"
                            v-on="{ ...tooltip, ...deleteRecipe}"
                            style="top: 110px; right: 25px;"
                        >
                            <v-icon>
                                delete
                            </v-icon>
                        </v-btn>
                    </template>
                    <span>
                        Delete
                    </span>
                </v-tooltip>

            </template>
            <v-card
                class="pb-5"
                style="overflow-y: hidden; overflow-x: hidden"
            >
                <v-row
                class="grey lighten-3"
                >
                    <v-card-title
                        class="headline ml-3"
                        primary-title
                    >
                        Delete Recipe
                    </v-card-title>
                    <v-btn
                        absolute
                        small
                        fab
                        class="mr-3 text-right"
                        style="top: 10px; right: 10px;"
                        @click.prevent="cancelDeleteRecipe"
                    >
                        <v-icon>
                        close
                        </v-icon>
                    </v-btn>
                </v-row>
                <v-row
                    no-gutters
                    class="my-5"
                    justify="center"
                >
                    Are you sure you want to permanently delete this recipe?
                </v-row>
                <v-row
                    no-gutters
                    justify="space-between"
                    class="px-5"
                >
                    <v-btn
                        @click.prevent="cancelDeleteRecipe"
                    >
                        CANCEL
                    </v-btn>
                    <v-btn
                        @click.prevent="deleteRecipe"
                    >
                        DELETE
                    </v-btn>
                </v-row>
            </v-card>
        </v-dialog>

                <!--------------------------------->
                <!--           Audited           -->
                <!--------------------------------->
         
        <v-tooltip
            v-if="account.account_type == 'super admin'"
            left
        >
            <template v-slot:activator="{ on: tooltip}">
                <v-btn
                    small
                    fab
                    fixed
                    top
                    right
                    :disabled="processing"
                    @click.prevent="audited = !audited"
                    v-on="{ ...tooltip}"
                    :depressed="audited"
                    style="top: 160px; right: 25px;"
                >
                    <v-icon
                        v-if="!audited"
                        color="error"
                    >
                        new_releases
                    </v-icon>
                    <v-icon
                        v-else
                        color="#74cf74"
                    >
                        verified
                    </v-icon>
                </v-btn>
            </template>
            <span
                v-if="thisRecipe.audited == null"
            >
                Not Audited
            </span>
            <span
                v-else
            >
                Audited {{moment(thisRecipe.audited).format("M[/]D[/]YYYY")}}
            </span>
        </v-tooltip>

                <!--------------------------------->
                <!--      Set Content Width      -->
                <!--------------------------------->
        <v-row
            class="mt-5"
            justify="center"
        >
            <v-col
                class="pt-0 px-5"
                xs="12"
                sm="12"
                md="10"
                lg="8"
                xl="6"
            >
            
                <!--------------------------------->
                <!--         Recipe Title        -->
                <!--------------------------------->
                <v-row
                    justify="center"
                    align="center"
                    style="font-size: 1.8em; font-weight: 500; color: #212121; letter-spacing: 1px;"
                    no-gutters
                >
                    Edit Recipe
                </v-row>

                <v-row
                    justify="center"
                    class="mt-5"
                    no-gutters
                >
                    <v-col
                        class="pa-0 ma-0"
                    >
                        <v-text-field
                            v-model="recipeName"
                            label="Recipe Name"
                            hide-details
                            height="50"
                            style="font-size: 1.6em; font-weight: 500; color: #212121; letter-spacing: 1px; margin: 0px 0px 0px 0px; padding: 0px 0px 0px 0px;"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row
                    justify="end"
                    class="pl-4"
                    no-gutters
                >
                    <v-col
                        cols="12"
                    >
                        <v-autocomplete
                            v-model="recipeSource"
                            label="Recipe Source"
                            :items="recipeSourceOptions"
                            :no-data-text="recipeSourceOptions.length < 1 ? 'loading options...' : 'not found'"
                            item-color="#32a852"
                            background-color="white"
                            height="30"
                            hide-details
                        ></v-autocomplete>
                    </v-col>
                </v-row>
                <v-row
                    v-if="recipeSource == 'Other'"
                    class="pl-8"
                    no-gutters
                >
                    <v-col
                        cols="12"
                    >
                        <v-autocomplete
                            v-model="recipeSourceType"
                            label="Recipe Source Type"
                            :items="recipeSourceTypes"
                            hide-details
                        ></v-autocomplete>
                    </v-col>
                </v-row>
                <v-row
                    v-if="recipeSourceType == 'Book' & recipeSource == 'Other'"
                    class="pl-12"
                    no-gutters
                >
                    <v-col
                        cols="12"
                    >
                        <v-text-field
                            v-model="bookTitle"
                            label="Book Title"
                            hide-details
                            height="30"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row
                    v-if="recipeSourceType == 'Book' & recipeSource == 'Other'"
                    class="pl-12"
                    no-gutters
                >
                    <v-col
                        cols="12"
                    >
                        <v-text-field
                            v-model="bookAuthor"
                            label="Author"
                            hide-details
                            height="30"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row
                    v-if="recipeSourceType == 'Website' & recipeSource == 'Other'"
                    class="pl-12"
                    no-gutters
                >
                    <v-col
                        cols="12"
                    >
                        <v-text-field
                            v-model="websiteName"
                            label="Website Name"
                            hide-details
                            height="30"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row
                    v-if="recipeSourceType == 'Website' & recipeSource == 'Other'"
                    class="pl-12"
                    no-gutters
                >
                    <v-col
                        cols="12"
                    >
                        <v-text-field
                            v-model="websiteURL"
                            label="Website URL"
                            hide-details
                            height="30"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row
                    v-if="(recipeSourceType == 'Website' & recipeSource == 'Other') | selectedRecipeSourceType == 'Website'"
                    :class="recipeSource == 'Other' ? 'pl-12' : 'pl-8'"
                    no-gutters
                >
                    <v-col
                        cols="12"
                    >
                        <v-text-field
                            v-model="directRecipeURL"
                            label="Direct Recipe URL"
                            append-icon="launch"
                            @click:append="openRecipeURL"
                            hide-details
                            height="30"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row
                    v-if="recipeSourceType == 'Individual' & recipeSource == 'Other'"
                    class="pl-12"
                    no-gutters
                >
                    <v-col
                        cols="12"
                    >
                        <v-text-field
                            v-model="individual"
                            label="Name of Recipe Provider"
                            hide-details
                            height="30"
                        ></v-text-field>
                    </v-col>
                </v-row>


                <!--------------------------------->
                <!--           Picture           -->
                <!--------------------------------->
                <v-row
                    class="mt-4"
                    justify="center"
                    no-gutters
                >
                    <v-col
                        class="ma-0 pa-0"
                        cols="12"
                    >
                        <v-card
                            flat
                        >
                            <v-btn
                                small
                                absolute
                                dark
                                fab
                                color="white"
                                @click="chooseImage"
                                style="top: 8px; right: 8px;"
                            >
                                <v-icon
                                    medium
                                    :color="imageDataset == null ? 'primary' : '#74cf74'"
                                >
                                    cloud_upload
                                </v-icon>
                            </v-btn>
                            <v-row
                                v-if="!imageDataset"
                                class="placeholder"
                                justify="center"
                                no-gutters
                            >
                                <v-img
                                    :src="selectedRecipeImageURL"
                                    aspect-ratio="1.8"
                                />
                                <input
                                    class="file-input"
                                    ref="fileInput"
                                    type="file"
                                    @input="onSelectFile"
                                >
                            </v-row>

                            <v-row
                                v-else
                                class="image-input"
                                justify="center"
                                :style="{ 'background-image': `url(${imageDataset})` }"
                                @click="chooseImage"
                                no-gutters
                            >
                                <input
                                    class="file-input"
                                    ref="fileInput"
                                    type="file"
                                    @input="onSelectFile"
                                >
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>

                <!--------------------------------->
                <!--       Recipe Metadata       -->
                <!--------------------------------->
                <v-row
                    class="black--text mt-1"
                    align="start"
                    no-gutters
                >
                    <!--         Photo Credit        -->
                    <v-col
                        class="px-1"
                        cols="12"
                        xs="12"
                        sm="6"
                        md="6"
                        lg="4"
                        xl="4"
                    >
                        <v-row
                            class="mt-5"
                            no-gutters
                        >
                            Photo By
                        </v-row>
                        <v-text-field
                            v-model="photoCredit"
                            height="20"
                            hide-details
                        ></v-text-field>
                    </v-col>

                    <!--           Prep Time         -->
                    <v-col
                        class="px-1"
                        cols="12"
                        xs="12"
                        sm="6"
                        md="6"
                        lg="4"
                        xl="4"
                    >
                        <v-row
                            class="mt-5 mb-5"
                            no-gutters
                        >
                            Total Time (minutes)
                        </v-row>
                        <v-slider
                            v-model="prepTime"
                            step="5"
                            max="90"
                            ticks
                            thumb-label= always
                            thumb-size="20"
                            :color="prepTime == 0 ? 'red' : '#74cf74'"
                            :track-color="prepTime == 0 ? 'red' : '#caedca'"
                            hide-details
                        ></v-slider>
                    </v-col>

                    <!--          Difficulty         -->
                    <v-col
                        class="px-1"
                        cols="12"
                        xs="12"
                        sm="6"
                        md="6"
                        lg="4"
                        xl="4"
                    >
                        <v-row
                            class="mt-5 mb-5"
                            no-gutters
                        >
                            Difficulty
                        </v-row>
                        <v-slider
                            v-model="difficulty"
                            step="1"
                            max="10"
                            ticks
                            thumb-label= always
                            thumb-size="20"
                            :color="difficulty == 0 ? 'red' : '#74cf74'"
                            :track-color="difficulty == 0 ? 'red' : '#caedca'"
                            hide-details
                        ></v-slider>
                    </v-col>
                </v-row>

                <v-row
                    class="mt-2"
                    no-gutters
                >
                    <v-col
                        cols="12" 
                    >
                        <v-row
                            no-gutters
                        >
                            Meal Type
                        </v-row>
                        <div>
                            <v-row
                                no-gutters
                            >
                                <v-col
                                    v-for="(item,mt) in mealTypes"
                                    :key="mt"
                                    class="px-2"
                                    cols="6"
                                    xs="6"
                                    sm="3"
                                    md="2"
                                    lg="2"
                                    xl="2" 
                                >
                                    <v-checkbox
                                        v-model="mealType"
                                        :label="mealTypes[mt]"
                                        :value="mealTypes[mt]"
                                        class="mt-0 mb-2"
                                        hide-details
                                        color="#74cf74"
                                        height="15"
                                    >
                                    </v-checkbox>
                                </v-col>
                            </v-row>
                        </div>
                    </v-col>
                </v-row>

                <v-row
                    class="mt-5"
                    no-gutters
                >
                    <v-col
                        cols="12"
                    >
                        <v-row
                            no-gutters
                        >
                            Leftover Uses
                        </v-row>
                        <div>
                            <v-row
                                no-gutters
                            >
                                <v-col
                                    v-for="(item,lt) in leftoverTypes"
                                    :key="lt"
                                    class="px-2"
                                    cols="6"
                                    xs="6"
                                    sm="3"
                                    md="2"
                                    lg="2"
                                    xl="2"
                                >
                                    <v-checkbox
                                        v-model="leftoverType"
                                        :label="leftoverTypes[lt]"
                                        :value="leftoverTypes[lt]"
                                        class="mt-0 mb-2"
                                        hide-details
                                        color="#74cf74"
                                        height="15"
                                    >
                                    </v-checkbox>
                                </v-col>
                            </v-row>
                        </div>
                    </v-col>
                </v-row>

                <v-row
                    class="mt-5"
                    no-gutters
                >
                    <v-col
                        cols="12"
                    >
                        <v-row
                            no-gutters
                        >
                            Food Categories
                        </v-row>
                        <div>
                            <v-row
                                no-gutters
                            >
                                <v-col
                                    v-for="(item,i) in foodTypeOptions"
                                    :key="i"
                                    class="px-2"
                                    cols="6"
                                    xs="6"
                                    sm="3"
                                    md="2"
                                    lg="2"
                                    xl="2"
                                >
                                    <v-checkbox
                                        v-model="foodType"
                                        :label="foodTypeOptions[i].name"
                                        :value="foodTypeOptions[i].id"
                                        class="mt-0 mb-2"
                                        hide-details
                                        color="#74cf74"
                                        height="15"
                                    >
                                    </v-checkbox>
                                </v-col>
                            </v-row>
                        </div>
                    </v-col>
                    <!-- <v-col
                        cols="12"
                        xs="12"
                        sm="6"
                        md="4"
                        lg="3"
                        xl="3"  
                    >
                        <v-row
                            class="mt-5"
                            no-gutters
                        >
                            Compatible Diets
                        </v-row>
                        <div>
                            <v-row
                                v-for="(item,i) in diets"
                                :key="i"
                                class="ml-5"
                                no-gutters
                            >
                                <v-checkbox
                                    v-model="diet"
                                    :label="diets[i].name"
                                    :value="diets[i].id"
                                    hide-details
                                    color="#74cf74"
                                    height="15"
                                >
                                </v-checkbox>
                            </v-row>
                        </div>
                    </v-col> -->
                </v-row>


                <!--------------------------------->
                <!--         Ingredients         -->
                <!--------------------------------->

                <!--            Title            -->
                <v-row
                    align="center"
                    class="black--text mt-8"
                    no-gutters
                >
                    <v-col class="pb-0">
                        <h3>Ingredients:</h3>
                    </v-col>
                </v-row>

                <!--       Ingredient List       -->
                <v-row
                    align="center"
                    no-gutters
                >
                    <v-col
                        class="ml-5"
                    >
                        <v-dialog
                            v-model="editIngredient"
                            persistent
                            width="500"
                        >
                            <template v-slot:activator="{ on: editIngredient}">
                                <table>
                                    <tbody>
                                        <tr
                                            v-for="(ingredient,i) in ingredients"
                                            :key="i"
                                            class="body-2"
                                            height="30"
                                        >
                                            <td>
                                                <v-row
                                                    class="flex-nowrap"
                                                    no-gutters
                                                >
                                                    <v-col
                                                        class="mr-4"
                                                        style="align-items: center"
                                                    >
                                                         <v-tooltip
                                                            top
                                                        >
                                                            <template v-slot:activator="{ on: tooltip}">
                                                                <v-avatar
                                                                    class="avatar2"
                                                                    size="17"
                                                                    v-on="{ ...tooltip, ...editIngredient}"
                                                                    @click.prevent="editExistingIngredient(i)"
                                                                >
                                                                    <v-icon
                                                                        x-small
                                                                        color="white"
                                                                    >
                                                                        edit
                                                                    </v-icon>
                                                                </v-avatar>
                                                            </template>
                                                            <span>
                                                                edit
                                                            </span>
                                                        </v-tooltip>
                                                    </v-col>

                                                    <v-col
                                                        class="mr-3"
                                                        style="align-items: center"
                                                    >
                                                        <v-tooltip
                                                            top
                                                        >
                                                            <template v-slot:activator="{ on: tooltip}">
                                                                <v-avatar
                                                                    class="avatar"
                                                                    size="17"
                                                                    v-on="{ ...tooltip}"
                                                                    @click.prevent="subtractIngredient(i)"
                                                                >
                                                                    <v-icon
                                                                        x-small
                                                                        color="white"
                                                                    >
                                                                        remove
                                                                    </v-icon>
                                                                </v-avatar>
                                                            </template>
                                                            <span>
                                                                remove
                                                            </span>
                                                        </v-tooltip>
                                                    </v-col>
                                                </v-row>
                                            </td>
                                            <td>
                                                <div
                                                    class="mr-2 text-no-wrap"
                                                >
                                                    {{amountDisplay(ingredient.amount)}} {{ingredient.displayUnit}}
                                                </div>
                                            </td>
                                            <td>
                                                <b>{{nameDisplay({name: ingredient.name, quantity: ingredient.amount, plural: ingredient.plural})}}</b> {{prepDisplay(ingredient.preparation)}}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </template>

                            <!-- edit ingredient dialog content -->
                            <v-card
                                class="pb-5"
                                style="overflow: hidden"
                            >
                                <v-row
                                    class="grey lighten-3"
                                >
                                    <v-card-title
                                        class="headline ml-3"
                                        primary-title
                                    >
                                        Edit Ingredient
                                    </v-card-title>
                                </v-row>
                                <v-row>
                                    <v-col
                                        class="px-10"
                                    >
                                        <v-row
                                            align="center"
                                            no-gutters
                                        >
                                            <v-col>
                                                <v-text-field
                                                    v-model="ingredientToEdit.name"
                                                    label="Ingredient"
                                                    disabled
                                                    hide-details
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row
                                            no-gutters
                                        >
                                            <v-col
                                                cols="6"
                                                class="pr-2"
                                            >
                                                <v-text-field
                                                    v-model="ingredientToEdit.amount"
                                                    label="Amount"
                                                    type="number"
                                                    hide-details
                                                    @keydown.enter="saveEditIngredient"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col
                                                cols="6"
                                                class="pl-2"
                                            >
                                                <v-select
                                                    v-model="ingredientToEdit.unit"
                                                    label="Units"
                                                    :items="ingredientToEdit.unit == 'count' ? ['count'] : unitOptions"
                                                    :disabled="ingredientToEdit.unit == 'count' ? true : false"
                                                    hide-details
                                                    @keydown.enter="saveEditIngredient"
                                                ></v-select>
                                            </v-col>
                                        </v-row>
                                        <v-row
                                            no-gutters
                                        >
                                            <v-text-field
                                                v-model="ingredientToEdit.preparation"
                                                label="Preparation"
                                                hide-details
                                                @keydown.enter="saveEditIngredient"
                                            ></v-text-field>
                                        </v-row>
                                    </v-col>
                                </v-row>
                                <v-row
                                    class="mt-5 mx-5 pa-0"
                                >
                                    <v-col
                                        class="text-right ma-0 pa-0"
                                    >
                                        <v-btn
                                            color="blue"
                                            class="mt-0 white--text"
                                            @click.prevent="saveEditIngredient"
                                            :disabled="!readyToSaveEditIngredient"
                                        >
                                            Save
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-dialog>

                    </v-col>
                </v-row>

                <!--       Add Ingredients       -->
                <v-row
                    class="mt-2 mx-5"
                    justify="start"
                    no-gutters
                >
                    <v-col
                        class="shrink ml-2"
                    >
                        <v-dialog
                            v-model="addIngredient"
                            persistent
                            width="500"
                        >
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    fab
                                    x-small
                                    color="#74cf74"
                                    v-on="on"
                                >
                                    <v-icon
                                        medium
                                        color="#ffffff"
                                    >
                                        add
                                    </v-icon>
                                </v-btn>
                            </template>

                            <v-card
                                class="pb-5"
                                style="overflow: hidden"
                            >
                                <v-row
                                    class="grey lighten-3"
                                >
                                    <v-card-title
                                        class="headline ml-3"
                                        primary-title
                                    >
                                        Add Ingredient
                                    </v-card-title>
                                    <v-btn
                                        absolute
                                        small
                                        fab
                                        class="mr-3 text-right"
                                        style="top: 10px; right: 10px;"
                                        @click="cancelAddIngredient"
                                    >
                                        <v-icon>
                                            close
                                        </v-icon>
                                    </v-btn>
                                </v-row>
                                <v-row>
                                    <v-col
                                        class="px-10"
                                    >
                                        <v-row
                                            align="center"
                                            no-gutters
                                        >
                                            <v-col>
                                                <v-autocomplete
                                                    id="ingredient"
                                                    v-model="ingredientToAdd"
                                                    label="Ingredient"
                                                    :items="ingredient"
                                                    hide-details
                                                    v-on:input="newIngredientUpdated"
                                                    @keydown.enter="saveIngredient"
                                                    @keydown.esc="cancelAddIngredient"
                                                ></v-autocomplete>
                                            </v-col>
                                            <v-col
                                                class="shrink ml-2"
                                            >
                                                <v-btn
                                                    v-if="!createNewIngredientBoolean"
                                                    fab
                                                    x-small
                                                    @click.prevent="createNewIngredient"
                                                    color="#74cf74"
                                                >
                                                    <v-icon
                                                        color="#ffffff"
                                                        medium
                                                    >
                                                        add
                                                    </v-icon>
                                                </v-btn>
                                                <v-btn
                                                    v-if="createNewIngredientBoolean"
                                                    fab
                                                    x-small
                                                    @click.prevent="cancelCreateNewIngredient"
                                                    color=error
                                                >
                                                    <v-icon
                                                        color="#ffffff"
                                                        medium
                                                    >
                                                        close
                                                    </v-icon>
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                        <v-row
                                            v-if="!createNewIngredientBoolean && ingredientToAdd != null"
                                            no-gutters
                                        >
                                            <v-col
                                                cols="6"
                                                class="pr-2"
                                            >
                                                <v-text-field
                                                    v-model="amount"
                                                    label="Amount"
                                                    type="number"
                                                    hide-details
                                                    @keydown.enter="saveIngredient"
                                                    @keydown.esc="cancelAddIngredient"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col
                                                cols="6"
                                                class="pl-2"
                                            >
                                                <v-select
                                                    v-model="units"
                                                    label="Units"
                                                    :items="ingredientToAddMeasurementUnit == 'count' ? ['count'] : unitOptions"
                                                    :disabled="ingredientToAddMeasurementUnit == 'count' ? true : false"
                                                    hide-details
                                                    @keydown.enter="saveIngredient"
                                                    @keydown.esc="cancelAddIngredient"
                                                ></v-select>
                                            </v-col>
                                        </v-row>
                                        <v-row
                                            v-if="!createNewIngredientBoolean && ingredientToAdd != null"
                                            no-gutters
                                        >
                                            <v-text-field
                                                v-model="preparation"
                                                label="Preparation"
                                                hide-details
                                                @keydown.enter="saveIngredient"
                                                @keydown.esc="cancelAddIngredient"
                                            ></v-text-field>
                                        </v-row>

                <!--    Create New Ingredient    -->
                                        <v-card
                                            class="mt-2"
                                            flat
                                            v-if="createNewIngredientBoolean"
                                        >
                                            <v-row
                                                no-gutters
                                            >
                                                <v-col>
                                                    <v-simple-table dense>
                                                        <template v-slot:default>
                                                            <tbody>
                                                                <tr>
                                                                    <td colspan="2" class="black"/>
                                                                </tr>
                                                                <tr>
                                                                    <td colspan="2">
                                                                        <v-col
                                                                            class="mb-1 pa-0"
                                                                        >
                                                                            <v-text-field
                                                                                v-model="newIngredientName"
                                                                                label="New Ingredient Name"
                                                                                hide-details
                                                                                height="30"
                                                                                @keydown.enter="saveNewIngredient"
                                                                                @keydown.esc="cancelCreateNewIngredient"
                                                                            ></v-text-field>
                                                                        </v-col>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td colspan="2">
                                                                        <v-col
                                                                            class="mb-1 pa-0"
                                                                        >
                                                                            <v-autocomplete
                                                                                v-model="storeSection"
                                                                                label="Section in Store"
                                                                                :items="storeSections"
                                                                                hide-details
                                                                                height="30"
                                                                                @keydown.enter="saveNewIngredient"
                                                                                @keydown.esc="cancelCreateNewIngredient"
                                                                            ></v-autocomplete>
                                                                        </v-col>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td colspan="2">
                                                                        <v-row
                                                                            no-gutters
                                                                        >
                                                                            <v-col
                                                                                cols="4"
                                                                                class="mb-1 pr-2"
                                                                            >
                                                                                <v-text-field
                                                                                    v-model="newIngredientUnitQuantity"
                                                                                    label="Quantity"
                                                                                    type="number"
                                                                                    hide-details
                                                                                    height="30"
                                                                                    @keydown.enter="saveNewIngredient"
                                                                                    @keydown.esc="cancelCreateNewIngredient"
                                                                                ></v-text-field>
                                                                            </v-col>
                                                                            <v-col
                                                                                class="mb-1 pl-2"
                                                                            >
                                                                                <v-select
                                                                                    v-model="newIngredientUnit"
                                                                                    :items="unitOptionsNew"
                                                                                    label="Units"
                                                                                    hide-details
                                                                                    height="30"
                                                                                    @keydown.enter="saveNewIngredient"
                                                                                    @keydown.esc="cancelCreateNewIngredient"
                                                                                ></v-select>
                                                                            </v-col>
                                                                        </v-row>
                                                                    </td>
                                                                </tr>
                                                                <tr
                                                                    v-if="newIngredientUnit == 'count'"
                                                                >
                                                                    <td colspan="2">
                                                                        <v-col
                                                                            class="mb-1 pa-0"
                                                                        >
                                                                            <v-text-field
                                                                                v-model="newIngredientPlural"
                                                                                label="New Ingredient Name (Plural)"
                                                                                hide-details
                                                                                height="30"
                                                                                @keydown.enter="saveNewIngredient"
                                                                                @keydown.esc="cancelCreateNewIngredient"
                                                                            ></v-text-field>
                                                                        </v-col>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td colspan="2">
                                                                        <v-col
                                                                            class="mb-1 pa-0"
                                                                        >
                                                                            <v-autocomplete
                                                                                v-model="newIngredientAllergy"
                                                                                :items="newIngredientAllergy.includes('none',0) ? ['none'] : allergies"
                                                                                item-text="name"
                                                                                item-value="id"
                                                                                label="Allergies"
                                                                                item-color="#32a852"
                                                                                hide-details
                                                                                multiple
                                                                                height="40"
                                                                            >
                                                                                <template
                                                                                    v-slot:selection="{ item, index }"
                                                                                >
                                                                                    <v-chip
                                                                                        v-if="index < 4"
                                                                                    >
                                                                                        <span>
                                                                                            {{ item.name }}
                                                                                        </span>
                                                                                    </v-chip>
                                                                                    <span
                                                                                        v-if="index === 4"
                                                                                        class="grey--text caption"
                                                                                    >
                                                                                        (+{{ newIngredientAllergy.length - 4 }} more)
                                                                                    </span>
                                                                                </template>
                                                                            </v-autocomplete>
                                                                        </v-col>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td colspan="2" class="black"/>
                                                                </tr>
                                                                <tr v-for="item in nutrition" :key="item.category">
                                                                    <td><div :class="[item.ml, item.fontWeight]"> {{item.category}} </div></td>
                                                                    <td
                                                                        class="text-right"
                                                                        width="150"
                                                                        height="30"
                                                                    >
                                                                        <v-text-field
                                                                            v-model="item.amount"
                                                                            :suffix="item.unit"
                                                                            type="number"
                                                                            hide-details
                                                                            dense
                                                                            solo
                                                                            @keydown.enter="saveNewIngredient"
                                                                            @keydown.esc="cancelCreateNewIngredient"
                                                                        ></v-text-field>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td colspan="2" class="black"/>
                                                                </tr>
                                                            </tbody>
                                                        </template>
                                                    </v-simple-table>
                                                    <v-row
                                                        class="my-2 mx-5"
                                                        no-gutters
                                                    >
                                                        <v-col
                                                            class="text-right pa-0"
                                                        >
                                                            <v-btn
                                                                color="#74cf74"
                                                                class="mt-0 white--text"
                                                                @click.prevent="saveNewIngredient"
                                                                :disabled="disableCreateIngredient"
                                                            >
                                                                Create Ingredient
                                                            </v-btn>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                            </v-row>
                                        </v-card>
                                    </v-col>
                                </v-row>
                                <v-row
                                    v-if="!createNewIngredientBoolean"
                                    class="mt-5 mx-5 pa-0"
                                >
                                    <v-col
                                        class="text-left ma-0 pa-0"
                                    >
                                        <v-btn
                                            color="red"
                                            class="mt-0 white--text"
                                            @click.prevent="cancelAddIngredient"
                                        >
                                            close
                                        </v-btn>
                                    </v-col>
                                    <v-col
                                        class="text-right ma-0 pa-0"
                                    >
                                        <v-btn
                                            color="blue"
                                            class="mt-0 white--text"
                                            @click.prevent="saveIngredient"
                                            :disabled="!readyToSaveIngredient"
                                        >
                                            Save
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-dialog>
                    </v-col>
                </v-row>

                <!--------------------------------->
                <!--          Directions         -->
                <!--------------------------------->
                
                <!--            Title            -->
                <v-row
                    align="center"
                    class="black--text mt-5"
                    no-gutters
                >
                    <v-col class="pb-0">
                        <h3>Directions:</h3>
                    </v-col>
                </v-row>

                <!--             List            -->
                <v-row
                    no-gutters
                    align="center"
                >
                    <v-col
                        class="ml-5"
                    >
                         <v-dialog
                            v-model="editDirections"
                            persistent
                            width="500"
                        >
                            <template v-slot:activator="{ on: editDirections}">
                                <table
                                    vertical-align="top"
                                >
                                    <tbody>
                                        <tr
                                            v-for="(direction,d) in directions"
                                            :key="d"
                                            class="body-2"
                                            height="30"
                                        >
                                            <td>
                                                <v-row
                                                    class="flex-nowrap"
                                                    no-gutters
                                                >
                                                    <v-col
                                                        class="mr-4"
                                                        style="align-items: center"
                                                    >
                                                         <v-tooltip
                                                            top
                                                        >
                                                            <template v-slot:activator="{ on: tooltip}">
                                                                <v-avatar
                                                                    class="avatar2"
                                                                    size="17"
                                                                    v-on="{ ...tooltip, ...editDirections}"
                                                                    @click.prevent="editInstructions(d)"
                                                                >
                                                                    <v-icon
                                                                        x-small
                                                                        color="white"
                                                                    >
                                                                        edit
                                                                    </v-icon>
                                                                </v-avatar>
                                                            </template>
                                                            <span>
                                                                edit
                                                            </span>
                                                        </v-tooltip>
                                                    </v-col>

                                                    <v-col
                                                        class="mr-3"
                                                        style="align-items: center"
                                                    >
                                                        <v-tooltip
                                                            top
                                                        >
                                                            <template v-slot:activator="{ on: tooltip}">
                                                                <v-avatar
                                                                    class="avatar"
                                                                    size="17"
                                                                    v-on="{ ...tooltip}"
                                                                    @click.prevent="subtractInstruction(d)"
                                                                >
                                                                    <v-icon
                                                                        x-small
                                                                        color="white"
                                                                    >
                                                                        remove
                                                                    </v-icon>
                                                                </v-avatar>
                                                            </template>
                                                            <span>
                                                                remove
                                                            </span>
                                                        </v-tooltip>
                                                    </v-col>
                                                </v-row>
                                            </td>
                                            <td>
                                                <div class="mr-2 text-no-wrap">{{direction.number}}.</div>
                                            </td>
                                            <td>
                                                {{direction.directions}}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </template>
                            <!-- edit directions dialog content -->
                            <v-card
                                class="pb-5"
                                style="overflow: hidden"
                            >
                                <v-row
                                    class="grey lighten-3"
                                >
                                    <v-card-title
                                        class="headline ml-3"
                                        primary-title
                                    >
                                        Edit Step {{directionToEdit.number}}
                                    </v-card-title>
                                </v-row>
                                <v-row>
                                    <v-col
                                        class="px-10"
                                    >
                                        <v-row>
                                            <v-textarea
                                                v-model="directionToEdit.directions"
                                                label="Instructions"
                                                outlined
                                                @keydown.enter="saveEditDirection"
                                            ></v-textarea>
                                        </v-row>
                                    </v-col>
                                </v-row>
                                <v-row
                                    class="mt-0 mx-5 pa-0"
                                >
                                    <v-col
                                        class="text-right ma-0 pa-0"
                                    >
                                        <v-btn
                                            color="blue"
                                            class="mt-0 white--text"
                                            @click.prevent="saveEditDirection"
                                            :disabled="!readyToSaveEditDirection"
                                        >
                                            Save
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-dialog>
                    </v-col>
                </v-row>

                <!--         Add Direction       -->
                <v-row
                    class="mt-2 mx-5"
                    justify="start"
                    no-gutters
                >
                    <v-col
                        class="shrink ml-2"
                    >
                        <v-dialog
                            v-model="addDirection"
                            persistent
                            width="500"
                            >
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    fab
                                    x-small
                                    v-on="on"
                                    color="#74cf74"
                                >
                                    <v-icon
                                        medium
                                        color="#ffffff"
                                    >
                                        add
                                    </v-icon>
                                </v-btn>
                            </template>

                            <v-card
                                class="pb-5"
                                style="overflow: hidden"
                            >
                                <v-row
                                    class="grey lighten-3"
                                >
                                    <v-card-title
                                        class="headline ml-3"
                                        primary-title
                                    >
                                        Add Step {{directions.length + 1}}
                                    </v-card-title>
                                    <v-btn
                                        absolute
                                        small
                                        fab
                                        class="mr-3 text-right"
                                        style="top: 10px; right: 10px;"
                                        @click="cancelAddDirection"
                                    >
                                        <v-icon>
                                            close
                                        </v-icon>
                                    </v-btn>
                                </v-row>
                                <v-row>
                                    <v-col
                                        class="px-10"
                                    >
                                        <v-row>
                                            <v-textarea
                                                id="instruction"
                                                v-model="instruction"
                                                label="Instructions"
                                                outlined
                                                @keydown.enter="saveDirection"
                                                @keyup.enter="directionKeyUp"
                                                @keyup.esc="cancelAddDirection"
                                            ></v-textarea>
                                        </v-row>
                                    </v-col>
                                </v-row>
                                <v-row
                                    class="mt-0 mx-5 pa-0"
                                >
                                    <v-col
                                        class="text-left ma-0 pa-0"
                                    >
                                        <v-btn
                                            color="red"
                                            class="mt-0 white--text"
                                            @click.prevent="cancelAddDirection"
                                        >
                                            close
                                        </v-btn>
                                    </v-col>
                                    <v-col
                                        class="text-right ma-0 pa-0"
                                    >
                                        <v-btn
                                            color="blue"
                                            class="mt-0 white--text"
                                            @click.prevent="saveDirection"
                                            :disabled="!readyToSaveDirection"
                                        >
                                            Save
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-dialog>
                    </v-col>
                </v-row>

                <!------------------------------>
                <!--      nutrition info      -->
                <!------------------------------>
                <v-row
                    class="mt-10"
                    no-gutters
                    justify="start"
                    style="font-size: 1.2em; font-weight: 600; color: #000000;"
                >    
                    Nutrition Information:
                </v-row>
                <v-row
                    justify="center"
                    no-gutters
                >
                    <v-col
                        class="my-5 px-5"
                        cols="12"
                        xs="12"
                        sm="12"
                        md="6"
                        lg="6"
                        xl="6"
                    >
                        <v-simple-table dense>
                            <template v-slot:default>
                                <tbody>
                                    <tr>
                                        <td colspan="2" class="black"/>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div
                                                class="font-weight-bold"
                                            >
                                                Total Recipe Calories
                                            </div>
                                        </td>
                                        <td
                                            class='text-right'
                                        >
                                            {{thisRecipeNutrition.totalCalories}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" class="black"/>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div
                                                class="ml-0 font-weight-bold"
                                            >
                                                Total Fat
                                            </div></td>
                                        <td
                                            class="text-right"
                                        >
                                            {{thisRecipeNutrition.totalFat}} g
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div
                                                class="ml-4 font-weight-regular"
                                            >
                                                Saturated Fat
                                            </div></td>
                                        <td
                                            class="text-right"
                                        >
                                            {{thisRecipeNutrition.saturatedFat}} g
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div
                                                class="ml-4 font-weight-regular"
                                            >
                                                Trans Fat
                                            </div></td>
                                        <td
                                            class="text-right"
                                        >
                                            {{thisRecipeNutrition.transFat}} g
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div
                                                class="ml-4 font-weight-regular"
                                            >
                                                Polyunsaturated Fat
                                            </div></td>
                                        <td
                                            class="text-right"
                                        >
                                            {{thisRecipeNutrition.polyunsaturatedFat}} g
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div
                                                class="ml-4 font-weight-regular"
                                            >
                                                Monounsaturated Fat
                                            </div></td>
                                        <td
                                            class="text-right"
                                        >
                                            {{thisRecipeNutrition.monounsaturatedFat}} g
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div
                                                class="ml-0 font-weight-bold"
                                            >
                                                Cholesterol
                                            </div></td>
                                        <td
                                            class="text-right"
                                        >
                                            {{thisRecipeNutrition.cholesterol}} mg
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div
                                                class="ml-0 font-weight-bold"
                                            >
                                                Sodium
                                            </div></td>
                                        <td
                                            class="text-right"
                                        >
                                            {{thisRecipeNutrition.sodium}} mg
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div
                                                class="ml-0 font-weight-bold"
                                            >
                                                Total Carbohydrate
                                            </div></td>
                                        <td
                                            class="text-right"
                                        >
                                            {{thisRecipeNutrition.totalCarbohydrate}} g
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div
                                                class="ml-4 font-weight-regular"
                                            >
                                                Dietary Fiber
                                            </div></td>
                                        <td
                                            class="text-right"
                                        >
                                            {{thisRecipeNutrition.dietaryFiber}} g
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div
                                                class="ml-4 font-weight-regular"
                                            >
                                                Sugars
                                            </div></td>
                                        <td
                                            class="text-right"
                                        >
                                            {{thisRecipeNutrition.sugars}} g
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div
                                                class="ml-0 font-weight-bold"
                                            >
                                                Protein
                                            </div></td>
                                        <td
                                            class="text-right"
                                        >
                                            {{thisRecipeNutrition.protein}} g
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" class="black"/>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                    <v-col
                        class="my-5 px-5"
                        cols="12"
                        xs="12"
                        sm="12"
                        md="6"
                        lg="6"
                        xl="6"
                    >
                        <v-row
                            justify="center"
                            no-gutters
                            style="font-size: 0.9em; font-weight: 500; color: #000000;"
                        >
                            % of Calories from Macros
                        </v-row>
                        <v-row
                            justify="center"
                        >
                            <div
                                style="width: 100%; height: 300px; pointer-events: none;"
                                ref="chartdiv"
                            />
                        </v-row>
                    </v-col>
                </v-row>

            </v-col>    <!-- end content width -->
        </v-row>
    </v-container>
</template>



<script>
let moment = require('moment');

//used for recipe chart of calories from fat, carbs, protein
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
am4core.useTheme(am4themes_animated);


export default {
    components: {

    },

    mounted() {
        this.rerenderChart += 1;
    },

    data: () => ({
        moment: moment,
        errorMessage: null,
        deleteRecipeDialog: false,
        units: null,
        chart: null,
        pieSeries: null,
        disabledUnits: 'count',
        imageData: null,
        imageDataset: null,
        amount: null,
        preparation: null,
        addIngredient: false,
        editIngredient: false,
        editDirections: false,
        ingredientToEdit: {},
        ingredientToEditIndex: null,
        directionToEdit: {},
        newIngredientName: null,
        newIngredientPlural: null,
        instruction: null,
        addDirection: false,
        recipeSourceType: null,
        recipeSourceTypes: ['Book','Website','Individual'],
        websiteURL: null,
        mealTypes: ['breakfast','lunch','dinner','snack'],
        leftoverTypes: ['breakfast','lunch','dinner','snack','none'],
        individual: null,
        bookTitle: null,
        bookAuthor: null,
        websiteName: null,
        newIngredientUnit: null,
        storeSection: null,
        newIngredientUnitQuantity: null,
        diet: [],
        newIngredientAllergy: [],
        storeSections: [
            'Bakery'
            ,'Baking'
            ,'Condiments'
            ,'Dairy'
            ,'Frozen Foods'
            ,'Grocery'
            ,'Lunch Meat/Cheese'
            ,'Meat/Seafood'
            ,'Produce'
            ,'Snacks'
            ,'Spices'
        ],
        nutrition: [
            {
                category: 'Total Fat',
                amount: null,
                unit: 'g',
                ml: 'ml-0',
                fontWeight: 'font-weight-bold'
            },
            {
                category: 'Saturated Fat',
                amount: null,
                unit: 'g',
                ml: 'ml-4',
                fontWeight: 'font-weight-regular'
            },
            {
                category: 'Trans Fat',
                amount: null,
                unit: 'g',
                ml: 'ml-4',
                fontWeight: 'font-weight-regular'
            },
            {
                category: 'Polyunsaturated Fat',
                amount: null,
                unit: 'g',
                ml: 'ml-4',
                fontWeight: 'font-weight-regular'
            },
            {
                category: 'Monounsaturated Fat',
                amount: null,
                unit: 'g',
                ml: 'ml-4',
                fontWeight: 'font-weight-regular'
            },
            {
                category: 'Cholesterol',
                amount: null,
                unit: 'mg',
                ml: 'ml-0',
                fontWeight: 'font-weight-bold'
            },
            {
                category: 'Sodium',
                amount: null,
                unit: 'mg',
                ml: 'ml-0',
                fontWeight: 'font-weight-bold'
            },
            {
                category: 'Total Carbohydrate',
                amount: null,
                unit: 'g',
                ml: 'ml-0',
                fontWeight: 'font-weight-bold'
            },
            {
                category: 'Dietary Fiber',
                amount: null,
                unit: 'g',
                ml: 'ml-4',
                fontWeight: 'font-weight-regular'
            },
            {
                category: 'Sugars',
                amount: null,
                unit: 'g',
                ml: 'ml-4',
                fontWeight: 'font-weight-regular'
            },
            {
                category: 'Protein',
                amount: null,
                unit: 'g',
                ml: 'ml-0',
                fontWeight: 'font-weight-bold'
            },
        ],
        rerenderChart: 0,
    }),

    methods: {
        chooseImage () {
            this.$refs.fileInput.click()
        },

        onSelectFile () {
            const input = this.$refs.fileInput
            const files = input.files
            if (files && files[0]) {
                const reader = new FileReader
                reader.onload = e => {
                    this.imageDataset = e.target.result;
                    this.fileType = e.target.result.split('/')[1].split(';')[0];
                    this.imageData = e.target.result.split(',')[1];
                }
                reader.readAsDataURL(files[0])
                this.$emit('input', files[0])
            }
        },

        cancelAddIngredient () {
            this.addIngredient = false;
            this.amount = null;
            this.units = null;
            this.ingredientToAdd = null;
            this.preparation = null;
            this.clearCreateIngredientData();
        },

        saveEditIngredient () {
            if (this.readyToSaveEditIngredient) {
                this.ingredientToEdit.displayUnit = null;
                if (this.ingredientToEdit.unit != 'count') {
                    this.ingredientToEdit.displayUnit = this.ingredientToEdit.unit
                }

                // console.log('this.ingredientToEdit',this.ingredientToEdit);
                // console.log('this.ingredients[this.ingredientToEdit.index]',this.ingredients[this.ingredientToEdit.index]);
                
                //this.ingredients[value.index] = this.value;
                this.editIngredient = false;
                this.ingredientToEdit = {};
            }
        },

        saveEditDirection () {
            if (this.readyToSaveEditDirection) {
                this.directions[this.directionToEdit.index] = this.directionToEdit;
                this.editDirections = false;
            }
        },

        saveIngredient () {
            let displayUnits = null;
            if (this.units != 'count') {
                displayUnits = this.units
            }

            if (this.readyToSaveIngredient == true) {
                this.ingredients.push({
                    name: this.ingredientToAdd,
                    plural: this.plural,
                    amount: this.amount,
                    unit: this.units,
                    displayUnit: displayUnits,
                    preparation: this.preparation,
                });
                this.amount = null;
                this.units = null;
                this.ingredientToAdd = null;
                this.preparation = null;
                document.getElementById("ingredient").focus();
            }
            this.clearCreateIngredientData();
            
            this.rerender += 1;
        },
        

        clearCreateIngredientData() {
            this.newIngredientName = null;
            this.newIngredientPlural = null;
            this.newIngredientUnit = null;
            this.storeSection = null;
            this.newIngredientUnitQuantity = null;
            this.newIngredientUnit = null;
            this.newIngredientAllergy = [];
            this.nutrition[0].amount = null;
            this.nutrition[1].amount = null;
            this.nutrition[2].amount = null;
            this.nutrition[3].amount = null;
            this.nutrition[4].amount = null;
            this.nutrition[5].amount = null;
            this.nutrition[6].amount = null;
            this.nutrition[7].amount = null;
            this.nutrition[8].amount = null;
            this.nutrition[9].amount = null;
            this.nutrition[10].amount = null;
            this.createNewIngredientBoolean = false;
        },

        cancelAddDirection() {
            this.addDirection = false;
            this.instruction = null;
        },

        saveDirection() {
            if (this.readyToSaveDirection == true) {
                this.directions.push({
                    number: this.directions.length + 1,
                    directions: this.instruction,
                });
                this.instruction = null;
                document.getElementById("instruction").focus();
            }
        },

        directionKeyUp() {
            this.instruction = null;
        },

        subtractIngredient(index) {
            this.ingredients.splice(index,1);
        },

        editExistingIngredient(index) {
            this.ingredientToEdit = this.ingredients[index];
            this.ingredientToEdit.index = index;
        },

        editInstructions(index) {
            this.directionToEdit = this.directions[index];
            this.directionToEdit.index = index;
        },

        subtractInstruction(index) {
            this.directions.splice(index,1);

            for (let i = 0; i < this.directions.length; i++) {
                this.directions[i].number = i+1;
            }
        },

        createNewIngredient() {
            this.createNewIngredientBoolean = true;
            this.ingredientToAdd = 'Add New'
        },

        cancelCreateNewIngredient() {
            this.createNewIngredientBoolean = false;
            this.ingredientToAdd = null;
            this.clearCreateIngredientData();
        },

        newIngredientUpdated() {
            if (this.ingredientToAdd == 'Add New'){
                this.createNewIngredientBoolean = true;
            } else {
                this.createNewIngredientBoolean = false;
            }
        },

        saveNewIngredient(){
            if (!this.disableCreateIngredient) {
                this.$store.dispatch('data/saveNewIngredient',
                    {
                        name: this.newIngredientName,
                        plural: this.newIngredientPlural,
                        storeSection: this.storeSection,
                        measurementUnit: this.newIngredientUnit,
                        gramsTotalFat: (this.nutrition[0].amount/this.newIngredientUnitQuantity),
                        gramsSaturatedFat: (this.nutrition[1].amount/this.newIngredientUnitQuantity),
                        gramsTransFat: (this.nutrition[2].amount/this.newIngredientUnitQuantity),
                        gramsPolyunsaturatedFat: (this.nutrition[3].amount/this.newIngredientUnitQuantity),
                        gramsMonounsaturatedFat: (this.nutrition[4].amount/this.newIngredientUnitQuantity),
                        milligramsCholesterol: (this.nutrition[5].amount/this.newIngredientUnitQuantity),
                        milligramsSodium: (this.nutrition[6].amount/this.newIngredientUnitQuantity),
                        gramsTotalCarbohydrate: (this.nutrition[7].amount/this.newIngredientUnitQuantity),
                        gramsDietaryFiber: (this.nutrition[8].amount/this.newIngredientUnitQuantity),
                        gramsSugars: (this.nutrition[9].amount/this.newIngredientUnitQuantity),
                        gramsProtein: (this.nutrition[10].amount/this.newIngredientUnitQuantity),
                        allergy: this.newIngredientAllergy
                    }
                );
                this.clearCreateIngredientData();
            }
        },

        editExistingRecipe() {
            this.errorMessage = null;
            let duplicateCheck = 0;
            let max = this.recipes.length;

            for (let i=0; i < max; i++){
                if (this.recipes[i].name.toLowerCase() == this.recipeName.toLowerCase() && this.recipes[i].id != this.thisRecipe.id){
                    duplicateCheck += 1;
                }
            }

            if (duplicateCheck == 0){
                if (!this.disableSaveEditRecipe) {
                    this.processing = true;
                    console.log('processing:',this.processing);
    
                    let link = null
                    if((this.recipeSourceType == 'Website' && this.recipeSource == 'Other') || this.selectedRecipeSourceType == 'Website'){
                        link = this.directRecipeURL;
                    } else {
                        link = null;
                    }
    
                    this.$store.dispatch('data/editExistingRecipe',
                        [
                            {
                                id: this.thisRecipe.id,
                                name: this.recipeName,
                                photoCredit: this.photoCredit,
                                recipeSourceLookupName: this.recipeSourceName,
                                recipeSourceURL: link,
                                mealType: this.mealType,
                                leftoverTypes: this.leftoverType,
                                difficulty: this.difficulty,
                                prepTimeMin: this.prepTime,
                                foodType: this.foodType,
                                audited: this.audited,
                            }
                            ,{
                                recipeSource: this.recipeSource,
                                type: this.recipeSourceType,
                                sourceName: this.recipeSourceName,
                                url: this.websiteURL,
                                author: this.bookAuthor
                            }
                        ]
                    );

                    if(this.imageData != null){
                        this.$store.dispatch('data/uploadPhoto',this.imageData);
                    }

                    this.clearRecipeData();
                }
            } else {
                this.errorMessage = 'Another recipe already exists named "';
                this.errorMessage += this.recipeName;
                this.errorMessage += '"';
            }

        },


        clearRecipeData() {
            this.recipeName = null;
            this.imageData = null;
            this.imageDataset = null;
            this.photoCredit = null;
            this.websiteName = null;
            this.bookTitle = null;
            this.individual = null;
            this.directRecipeURL = null;
            this.mealType = null;
            this.leftoverType = null;
            this.difficulty = null;
            this.prepTime = null;
            this.foodType = null;
            this.recipeSource = null;
            this.recipeSourceType = null;
            this.websiteURL = null;
            this.bookAuthor = null;
            this.ingredients = [];
            this.directions = [];
            this.diet = [];
            this.chart = null;
            this.pieSeries = null;
            this.audited = null;
        },

        nameDisplay(value) {
            if(value.plural != null && value.quantity > 1){
                return value.plural
            } else {
                return value.name
            }
        },

        prepDisplay(input) {
            if (input == null || input == '') {
                return null;
            } else {
                return ' - ('+input+')';
            }
        },

        amountDisplay(value){
            let num = Math.trunc(value)

            let prefix;
                if (num == 0) {
                    prefix = ""
                } else {
                    prefix = num.toString()
                }
            let suffix = ""

            if (Math.trunc((value - Math.trunc(value)) * 10000) == 625) {
                suffix == "1/16"
            } else if (Math.trunc((value - Math.trunc(value)) * 10000) == 1250) {
                suffix = "1/8"
            } else if (Math.trunc((value - Math.trunc(value)) * 10000) == 1875) {
                suffix = "3/16"
            } else if (Math.trunc((value - Math.trunc(value)) * 10000) == 2500) {
                suffix = "1/4"
            } else if (Math.trunc((value - Math.trunc(value)) * 10000) == 3125) {
                suffix = "5/16"
            } else if (Math.trunc((value - Math.trunc(value)) * 10000) == 3333) {
                suffix = "1/3"
            } else if (Math.trunc((value - Math.trunc(value)) * 10000) == 3750) {
                suffix = "3/8"
            } else if (Math.trunc((value - Math.trunc(value)) * 10000) == 4375) {
                suffix = "7/16"
            } else if (Math.trunc((value - Math.trunc(value)) * 10000) == 5000) {
                suffix = "1/2"
            } else if (Math.trunc((value - Math.trunc(value)) * 10000) == 5625) {
                suffix = "9/16"
            } else if (Math.trunc((value - Math.trunc(value)) * 10000) == 6250) {
                suffix = "5/8"
            } else if (Math.trunc((value - Math.trunc(value)) * 10000) == 6666) {
                suffix = "2/3"
            } else if (Math.trunc((value - Math.trunc(value)) * 10000) == 6875) {
                suffix = "11/16"
            } else if (Math.trunc((value - Math.trunc(value)) * 10000) == 7500) {
                suffix = "3/4"
            } else if (Math.trunc((value - Math.trunc(value)) * 10000) == 8125) {
                suffix = "13/16"
            } else if (Math.trunc((value - Math.trunc(value)) * 10000) == 8750) {
                suffix = "7/8"
            } else if (Math.trunc((value - Math.trunc(value)) * 10000) == 9375) {
                suffix = "15/16"
            }

            if (suffix == ""){
                return value;
            } else if (prefix == "") {
                return suffix;
            } else {
                return prefix.concat(" ",suffix)
            }
            
        },
        
        //CONFIRMED FOR EDIT RECIPE PAGE
        closeEditRecipe() {
            this.clearRecipeData();
            this.recipeDialog = false;
            this.editRecipe = false;
            this.rerender += 1;
            this.errorMessage = null;
        },

        cancelDeleteRecipe() {
            this.deleteRecipeDialog = false;
        },

        deleteRecipe() {
            this.recipeDialog = false;
            this.rerender += 1;
            this.$store.dispatch('data/deleteRecipe',this.thisRecipe.id);
        },

        openRecipeURL() {
            window.open(this.directRecipeURL);
        }

    },

    watch: {
        ingredientToAddMeasurementUnit() {
            if(this.ingredientToAddMeasurementUnit == 'count'){
                this.units = 'count';
            }
        },
        thisRecipeNutrition() {
            if (this.ingredients.length <1) {
                this.chart = null;
                this.pieSeries = null;
            }
            if (this.chart == null) {
                this.chart = am4core.create(this.$refs.chartdiv, am4charts.PieChart);
            }

            this.chart.data = [
                {
                source: "Fat",
                percent: this.thisRecipeNutrition.percent_calories_from_fat,
                color: am4core.color("#cfa274")
                },
                {
                source: "Protein",
                percent: this.thisRecipeNutrition.percent_calories_from_protein,
                color: am4core.color("#74cf74")
                },
                {
                source: "Carbs",
                percent: this.thisRecipeNutrition.percent_calories_from_carbs,
                color: am4core.color("#cf74cf")
                },
            ];
            //add and configure series
            if (this.pieSeries == null) {
                this.pieSeries = this.chart.series.push(new am4charts.PieSeries());
            }
            this.pieSeries.dataFields.value = "percent";
            this.pieSeries.dataFields.category = "source";
            
            // Set up slices
            this.pieSeries.slices.template.tooltipText = "";
            this.pieSeries.slices.template.alwaysShowTooltip = true;

            //add outline
            this.pieSeries.slices.template.stroke = am4core.color("#424242");
            this.pieSeries.slices.template.strokeWidth = 2;
            this.pieSeries.slices.template.strokeOpacity = 1;

            //move and format labels inside pie slice
            this.pieSeries.ticks.template.disabled = true;
            this.pieSeries.alignLabels = false;
            this.pieSeries.labels.template.text = "{category} \n {value}%";
            this.pieSeries.labels.template.radius = am4core.percent(-50);
            this.pieSeries.labels.template.fill = am4core.color("black");
            //this.pieSeries.labels.template.relativeRotation = 90;

            //color pie slices
            this.pieSeries.slices.template.propertyFields.fill = "color"
            
        }
    },

    computed: { 
        processing: {
            get() {
                return this.$store.getters['data/processing'];
            },
            set(value) {
                this.$store.dispatch('data/updateProcessing',value);
            }
        },

        allergies() {
            return this.$store.getters['data/allergies'];
        },

        fileType: {
            get() {
                return this.$store.getters['data/fileType'];
            },
            set(value) {
                this.$store.dispatch('data/updateFileType',value);
            }
        },

        ingredientToAdd: { //current ingredient selected to add
            get() {
                return this.$store.getters['data/ingredientToAdd'];
            },
            set(value) {
                this.$store.dispatch('data/updateIngredientToAdd',value)
            }
        },
        
        createNewIngredientBoolean: {
            get() {
                return this.$store.getters['data/addIngredient'];
            },
            set(value) {
                this.$store.dispatch('data/updateAddIngredient',value)
            }
        },

        getUnitOptions() {
            return this.$store.getters['data/conversionChart'];
        },

        unitOptions() {
            let list = [];
            let max = this.getUnitOptions.length;

            for (let i = 0; i < max; i++) {
                if (this.getUnitOptions[i].unit != 'count') {
                    list.push(this.getUnitOptions[i].unit)
                }
            }
            return list
        },

        unitOptionsNew() {
            let list = [];
            let max = this.getUnitOptions.length;

            for (let i = 0; i < max; i++) {
                list.push(this.getUnitOptions[i].unit)
            }
            return list
        },

        getIngredientOptions() {
            return this.$store.getters['data/ingredient'];
        },

        ingredient() {
            if(this.getIngredientOptions.length < 1){
                return []
            } else {
                let list = [];
                for (let i = 0; i < this.getIngredientOptions.length; i++) {
                    list.push(this.getIngredientOptions[i].name)
                }
                list.push('Add New')
                return list
            }
        },

        ingredientToAddMeasurementUnit() {
            let response = null;
            if (this.ingredientToAdd != null){
                let max = this.getIngredientOptions.length;

                for (let i=0; i < max; i++){
                    if (this.getIngredientOptions[i].name == this.ingredientToAdd) {
                        response = this.getIngredientOptions[i].measurement_unit;
                        i = max;
                    }
                }
            }
            return response;
        },

        plural() {
            let response = null;
            if (this.ingredientToAdd != null) {
                let max = this.getIngredientOptions.length;

                for (let i=0; i < max; i++){
                    if (this.getIngredientOptions[i].name == this.ingredientToAdd) {
                        console.log('this.getIngredientOptions[i]:',this.getIngredientOptions[i]);
                        response = this.getIngredientOptions[i].plural;
                        i=max;
                    }
                }
            }
            console.log('response:',response);
            return response;
        },

        getRecipeSourceOptions() {
            return this.$store.getters['data/recipeSource'];
        },

        foodTypeOptions() {
            return this.$store.getters['data/foodTypes'];
        },

        recipeSourceOptions() {
            if(this.getRecipeSourceOptions.length < 1) {
                return []
            } else {
                let list = [];
                for (let i = 0; i < this.getRecipeSourceOptions.length; i++) {
                    list.push(this.getRecipeSourceOptions[i].source_name)
                }
                list.push('Other')
                return list
            }
        },

        readyToSaveIngredient() {
            if(
                this.amount == null ||
                this.units == null ||
                this.ingredient == null
            ) {
                return false
            } else {
                return true
            }
        },

        readyToSaveEditIngredient() {
            if (
                this.ingredientToEdit.amount == null ||
                this.ingredientToEdit.amount == '' ||
                this.ingredientToEdit.unit == null ||
                this.ingredientToEdit.unit == ''
            ) {
                return false
            } else {
                return true
            }
        },

        readyToSaveEditDirection() {
            if (
                this.directionToEdit.directions == null ||
                this.directionToEdit.directions == ''
            ) {
                return false;
            } else {
                return true;
            }
        },
        
        readyToSaveDirection() {
            if(
                this.instruction == null
            ) {
                return false
            } else {
                return true
            }
        },

        recipeSourceName() {
            if(this.recipeSource == 'Other'){
                if(this.recipeSourceType == 'Website'){
                    return this.websiteName;
                } else if (this.recipeSourceType == 'Book'){
                    return this.bookTitle;
                } else {
                    return this.individual;
                }
            } else {
                return this.recipeSource;
            }
        },

        disableCreateIngredient() {
            if(this.newIngredientName == null |
                this.newIngredientName == '' |
                (this.newIngredientPlural == null | this.newIngredientPlural == '' && this.newIngredientUnit == 'count') |
                this.newIngredientUnit == null |
                this.storeSection == null |
                this.storeSection == '' |
                this.newIngredientUnitQuantity == null |
                this.newIngredientUnitQuantity == '' |
                this.newIngredientUnit == null |
                this.newIngredientUnit == '' |
                this.nutrition[0].amount == null |
                this.nutrition[0].amount == '' |
                this.nutrition[1].amount == null |
                this.nutrition[1].amount == '' |
                this.nutrition[2].amount == null |
                this.nutrition[2].amount == '' |
                this.nutrition[3].amount == null |
                this.nutrition[3].amount == '' |
                this.nutrition[4].amount == null |
                this.nutrition[4].amount == '' |
                this.nutrition[5].amount == null |
                this.nutrition[5].amount == '' |
                this.nutrition[6].amount == null |
                this.nutrition[6].amount == '' |
                this.nutrition[7].amount == null |
                this.nutrition[7].amount == '' |
                this.nutrition[8].amount == null |
                this.nutrition[8].amount == '' |
                this.nutrition[9].amount == null |
                this.nutrition[9].amount == '' |
                this.nutrition[10].amount == null |
                this.nutrition[10].amount == ''
            ) {
                return true
            } else {
                return false
            }
        },

        disableSaveEditRecipe() {
            if(
                this.recipeName == null |
                this.recipeName == '' |
                (this.selectedRecipeImageURL == null && (this.imageData == null |
                this.imageData == '')) |
                this.photoCredit == null |
                this.photoCredit == '' |
                this.recipeSourceName == null |
                this.recipeSourceName == '' |
                (this.recipeSourceType == 'Website' & this.recipeSource == 'Other' & this.directRecipeURL == null) |
                (this.recipeSourceType == 'Website' & this.recipeSource == 'Other' & this.directRecipeURL == '') |
                (this.selectedRecipeSourceType == 'Website' & this.directRecipeURL == null) |
                (this.selectedRecipeSourceType == 'Website' & this.directRecipeURL == '') |
                this.mealType == null |
                this.mealType == '' |
                this.leftoverType == null |
                this.leftoverType == '' |
                this.difficulty == 0 |
                this.prepTime == null |
                this.prepTime == '' |
                this.foodType == null |
                this.foodType == '' |
                this.ingredients == [] |
                this.directions == [] |
                this.diet == [] |
                this.ingredients.length < 1 |
                this.directions.length < 1
            ) {
                return true;
            } else {
                return false;
            }
        },

        thisRecipeNutrition() {
            let response = {
                totalCalories: 0,
                totalFat: 0,
                saturatedFat: 0,
                transFat: 0,
                polyunsaturatedFat: 0,
                monounsaturatedFat: 0,
                cholesterol: 0,
                sodium: 0,
                totalCarbohydrate: 0,
                dietaryFiber: 0,
                sugars: 0,
                protein: 0,
                percent_calories_from_fat: 0,
                percent_calories_from_protein: 0,
                percent_calories_from_carbs: 0
            };
            let ingredientsLength = this.ingredients.length;
            let ingredientOptionsLength = this.getIngredientOptions.length;
            let conversionChartLength = this.getUnitOptions.length;
            let multiplier = 0;

            if(ingredientsLength > 0){
                for (let i=0; i < ingredientsLength; i++) {
                    for (let j=0; j < ingredientOptionsLength; j++) {
                        if (this.ingredients[i].name == this.getIngredientOptions[j].name) {
    
                            // calculate nutrition information multiplier
                            for (let iu = 0; iu < conversionChartLength; iu++) {
                                if (this.getUnitOptions[iu].unit == this.ingredients[i].unit) {
                                    for (let ju = 0; ju < conversionChartLength; ju++) {
                                        if (this.getUnitOptions[ju].unit == this.getIngredientOptions[j].measurement_unit) {
                                            multiplier = (this.getUnitOptions[ju].quantity / this.getUnitOptions[iu].quantity);
                                            ju = this.conversionChartLength;
                                            iu = this.conversionChartLength;
                                        }
                                    }
                                }
                            }

                            multiplier = (multiplier * this.ingredients[i].amount);

                            // console.log('ingredients',this.ingredients[i]);
                            // console.log('getIngredientOptions',this.getIngredientOptions[j]);
                            // console.log('multiplier',multiplier);
    
                            response.totalCalories += this.getIngredientOptions[j].unit_calories * multiplier;
                            response.totalFat += this.getIngredientOptions[j].unit_grams_total_fat * multiplier;
                            response.saturatedFat += this.getIngredientOptions[j].unit_grams_saturated_fat * multiplier;
                            response.transFat += this.getIngredientOptions[j].unit_grams_trans_fat * multiplier;
                            response.polyunsaturatedFat += this.getIngredientOptions[j].unit_grams_polyunsaturated_fat * multiplier;
                            response.monounsaturatedFat += this.getIngredientOptions[j].unit_grams_monounsaturated_fat * multiplier;
                            response.cholesterol += this.getIngredientOptions[j].unit_milligrams_cholesterol * multiplier;
                            response.sodium += this.getIngredientOptions[j].unit_milligrams_sodium * multiplier;
                            response.totalCarbohydrate += this.getIngredientOptions[j].unit_grams_total_carbohydrate * multiplier;
                            response.dietaryFiber += this.getIngredientOptions[j].unit_grams_dietary_fibers * multiplier;
                            response.sugars += this.getIngredientOptions[j].unit_grams_sugars * multiplier;
                            response.protein += this.getIngredientOptions[j].unit_grams_protein * multiplier;

                            // console.log('response',response);
    
                        }
                    }
    
                }
    
                response.percent_calories_from_fat = ((response.totalFat * 9) / response.totalCalories)*100;
                response.percent_calories_from_protein = ((response.protein * 4) / response.totalCalories)*100;
                response.percent_calories_from_carbs = ((response.totalCarbohydrate * 4) / response.totalCalories)*100;
    
                //round entries
                response.totalCalories = Math.round(response.totalCalories);
                response.totalFat = Math.round(response.totalFat);
                response.saturatedFat = Math.round(response.saturatedFat);
                response.transFat = Math.round(response.transFat);
                response.polyunsaturatedFat = Math.round(response.polyunsaturatedFat);
                response.monounsaturatedFat = Math.round(response.monounsaturatedFat);
                response.cholesterol = Math.round(response.cholesterol);
                response.sodium = Math.round(response.sodium);
                response.totalCarbohydrate = Math.round(response.totalCarbohydrate);
                response.dietaryFiber = Math.round(response.dietaryFiber);
                response.sugars = Math.round(response.sugars);
                response.protein = Math.round(response.protein);
                response.percent_calories_from_fat = Math.round(response.percent_calories_from_fat);
                response.percent_calories_from_protein = Math.round(response.percent_calories_from_protein);
                response.percent_calories_from_carbs = Math.round(response.percent_calories_from_carbs);
                response.rerenderChart = this.rerenderChart;
    
            }

        return response
        },

    // CONFIRMED FOR EDIT RECIPE ADDITIONS
        account() {
            return this.$store.getters['data/account']
        },

        thisRecipe() {
            return this.$store.getters['data/thisRecipe'];
        },

        recipes() {
            return this.$store.getters['data/recipe'];
        },

        recipeDialog:{
            get(){
                return this.$store.getters['data/recipeDialog'];
            },
            set(value){
                this.$store.dispatch('data/updateRecipeDialog',value);
            }
        },

        editRecipe:{
            get(){
                return this.$store.getters['data/editRecipe'];
            },
            set(value){
                this.$store.dispatch('data/updateEditRecipe',value);
            }
        },

        rerender:{
            get(){
                return this.$store.getters['data/rerender'];
            },
            set(value){
                this.$store.dispatch('data/forceRerender',value);
            }
        },

        audited:{
            get(){
                return this.$store.getters['data/audited'];
            },
            set(value){
                this.$store.dispatch('data/updateAudited',value);
            }
        },

        recipeName:{
            get() {
                return this.$store.getters['data/recipeName'];
            },
            set(value){
                this.$store.dispatch('data/updateRecipeName',value);
            }
        },

        recipeSource:{
            get(){
                return this.$store.getters['data/thisRecipeSource'];
            },
            set(value){
                this.$store.dispatch('data/updateThisRecipeSource',value);
            }
        },

        selectedRecipeSourceType() {
            let max = this.getRecipeSourceOptions.length
            let response = null;
            
            if (this.recipeSource == 'Other'){
                response = null;
            } else {
                for (let i = 0; i < max; i++){
                    if(this.getRecipeSourceOptions[i].source_name == this.recipeSource) {
                        response = this.getRecipeSourceOptions[i].type;
                        i = max;
                    } 
                }
            }
            return response;
        },

        directRecipeURL:{
            get() {
                return this.$store.getters['data/directRecipeURL'];
            },
            set(value){
                this.$store.dispatch('data/updateDirectRecipeURL',value);
            }
        },

        selectedRecipeImageURL() {
            return this.$store.getters['data/selectedRecipeImageURL'];
        },

        photoCredit:{
            get(){
                return this.$store.getters['data/photoCredit'];
            },
            set(value){
                this.$store.dispatch('data/updatePhotoCredit',value);
            }
        },

        difficulty:{
            get(){
                return this.$store.getters['data/difficulty'];
            },
            set(value){
                this.$store.dispatch('data/updateDifficulty',value);
            }
        },

        prepTime:{
            get(){
                return this.$store.getters['data/prepTimeMin'];
            },
            set(value){
                this.$store.dispatch('data/updatePrepTimeMin',value);
            }
        },

        mealType:{
            get(){
                return this.$store.getters['data/mealType'];
            },
            set(value){
                this.$store.dispatch('data/updateMealType',value);
            }
        },

        leftoverType:{
            get(){
                return this.$store.getters['data/leftoverType'];
            },
            set(value){
                this.$store.dispatch('data/updateLeftoverType',value);
            }
        },

        foodType:{
            get(){
                return this.$store.getters['data/foodType'];
            },
            set(value){
                this.$store.dispatch('data/updateFoodType',value);
            }
        },

        ingredients: {
            get() {
                return this.$store.getters['data/ingredients'];
            },
            set(value) {
                this.$store.dispatch('data/updateIngredients',value)
            }
        },
        
        directions: {
            get() {
                return this.$store.getters['data/directions'];
            },
            set(value) {
                this.$store.dispatch('data/updateDirections',value)
            }
        },



        diets() {
            return this.$store.getters['data/diets'];
        },

        

        
      
    },

};
</script>

<style scoped>
    .image-input {
        display: block;
        width: 100%;
        padding-top: 55.69%;
        cursor: pointer;
        background-size: cover;
        background-position: center center;
    }

    .placeholder {
        background: #F0F0F0;
        width: 100%;
        min-height: 180px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #333;
        font-size: 18px;
        font-family: Helvetica;
    }

    .placeholder:hover {
        background: #E0E0E0;
    }

    .file-input {
        display: none;
    }
    
    .avatar {
        background: red;
    }

    .avatar2 {
        background: #1976D2;
    }

    .avatar:hover {
        background: #E57373;
    }

    .avatar2:hover {
        background: #6799c9;
    }

</style>